import { InfiniteSlider } from '@/js/infinite-slider';

export const CarFinancingView = {
    init() {
        InfiniteSlider.init();
        this.initCalculator();
    },

    initCalculator() {
        const inputs = {
            price: { range: document.getElementById('price-range'), text: document.getElementById('price-input') },
            age: { range: document.getElementById('age-range'), text: document.getElementById('age-input') },
            loan: { range: document.getElementById('loan-range'), text: document.getElementById('loan-input') },
            duration: { range: document.getElementById('duration-range'), text: document.getElementById('duration-input') }
        };


        const resetBtn = document.getElementById('reset-calculator-btn');
        const prefilledBox = document.querySelector('.prefilled-car-box'); // Changed to class selector as ID might be missing or duplicated if not careful

        if (resetBtn) {
            resetBtn.addEventListener('click', () => {

                if (prefilledBox) {
                    prefilledBox.style.display = 'none';
                }

                const slugInputs = document.querySelectorAll('input[name$="[slug]"]');
                slugInputs.forEach(input => {
                    input.value = '';
                });

                const priceRange = document.getElementById('price-range');
                if (priceRange) priceRange.value = 450000;

                const ageRange = document.getElementById('age-range');
                if (ageRange) ageRange.value = 3;

                const loanRange = document.getElementById('loan-range');
                if (loanRange) loanRange.value = 200000;

                const durationRange = document.getElementById('duration-range');
                if (durationRange) durationRange.value = 60;

                [priceRange, ageRange, loanRange, durationRange].forEach(range => {
                    if (range) {
                        range.dispatchEvent(new Event('input', { bubbles: true }));
                    }
                });
                    window.history.pushState({}, '', window.location.pathname);
            });
        }

        const displayPrice = document.getElementById('price-display');
        const monthlyPaymentEl = document.getElementById('monthly-payment');
        const rpsnEl = document.getElementById('rpsn');

        const interestRateEl = document.getElementById('interest-rate');

        const formatCurrency = (val) => new Intl.NumberFormat('cs-CZ').format(val).replace(/,/g, ' ') + ' Kč';
        const parseCurrency = (str) => parseInt(str.replace(/\D/g, ''), 10) || 0;

        const updateSliderFill = (rangeInput) => {
            const min = rangeInput.min || 0;
            const max = rangeInput.max || 100;
            const val = rangeInput.value;
            const percentage = ((val - min) / (max - min)) * 100;

            rangeInput.style.background = `linear-gradient(to right, #EE1B27 0%, #EE1B27 ${percentage}%, #E2E8F0 ${percentage}%, #E2E8F0 100%)`;
        };

        Object.keys(inputs).forEach(key => {
            const { range, text } = inputs[key];
            const suffix = key === 'duration' ? ' měsíců' : (key === 'age' ? (range.value < 5 ? ' roky' : ' let') : ' Kč');

            updateSliderFill(range);

            range.addEventListener('input', () => {
                let val = parseInt(range.value);
                let textVal = new Intl.NumberFormat('cs-CZ').format(val).replace(/,/g, ' ');
                if (key === 'age') {
                    text.value = val + (val === 1 ? ' rok' : (val >= 2 && val <= 4 ? ' roky' : ' let'));
                } else if (key === 'duration') {
                    text.value = val + ' měsíců';
                } else {
                    text.value = textVal + ' Kč';
                }

                if (key === 'price') {
                    displayPrice.textContent = text.value;
                }

                updateSliderFill(range);
                this.calculate();
            });

            // Button handlers
            const minusBtn = document.getElementById(`${key}-minus`);
            const plusBtn = document.getElementById(`${key}-plus`);

            if (minusBtn) {
                minusBtn.addEventListener('click', () => {
                    range.value = parseInt(range.value) - parseInt(range.step);
                    range.dispatchEvent(new Event('input'));
                });
            }

            if (plusBtn) {
                plusBtn.addEventListener('click', () => {
                    range.value = parseInt(range.value) + parseInt(range.step);
                    range.dispatchEvent(new Event('input'));
                });
            }
        });

        this.calculate = () => {
            const P = parseInt(inputs.loan.range.value); // Loan Amount
            const n = parseInt(inputs.duration.range.value); // Months

            let annualRatePercent = 4.3; // Default fallback
            let rpsnPercent = 4.39;      // Default fallback

            // Tiers logic
            //console.log("Calculate running. P:", P, "n:", n);

            if (P < 20000) {
                annualRatePercent = 13.9;
                rpsnPercent = 14.83;
            } else if (P < 50000) {
                annualRatePercent = 11.9;
                rpsnPercent = 12.58;
            } else if (P < 100000) {
                annualRatePercent = 8.9;
                rpsnPercent = 9.28;
            } else if (P < 200000) {
                annualRatePercent = 6.9;
                rpsnPercent = 7.13;
            } else {
                // >= 200 000
                annualRatePercent = 4.3;
                rpsnPercent = 4.39;
            }
            //console.log("Rate:", annualRatePercent, "RPSN:", rpsnPercent);

            const annualRate = annualRatePercent / 100;
            const r = annualRate / 12;

            // PMT Formula: P * r * (1+r)^n / ((1+r)^n - 1)
            const payment = (P * r * Math.pow(1 + r, n)) / (Math.pow(1 + r, n) - 1);

            const monthly = Math.round(payment);
            monthlyPaymentEl.textContent = formatCurrency(monthly);

            if (interestRateEl) {
                interestRateEl.textContent = annualRatePercent.toString().replace('.', ',') + " %";
            }
            rpsnEl.textContent = rpsnPercent.toString().replace('.', ',') + " %";
        };

        this.calculate();
    }
};
